import ImageNonResponsive from './ImageNonResponsive';

export default ImageNonResponsive;
